'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _analyticsUsers = require('./analytics-users.component');

var _analyticsUsers2 = _interopRequireDefault(_analyticsUsers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsModule = _angular2.default.module('app.containers.analytics-users', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('analyticsUsers', {
    url: '/analytics-users',
    template: '<analytics-users></analytics-users>'
  });
}).component('analyticsUsers', _analyticsUsers2.default);

exports.default = analyticsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-users/analytics-users.js
 **/